import { Box, InputBase, Stack, TextField, styled } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import palette from '../theme/palette';

export const InputContainer = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  borderRadius: 10,
  padding: '0.2rem 0.4rem',
  border: `1px solid ${palette.visitor.input.border}`,
  backgroundColor: palette.visitor.input.bg,
}));

export const StyledInput = styled(InputBase)(({ theme }) => ({
  marginLeft: 8,
  fontSize: '0.8rem',
  fontWeight: 500,
  fontFamily: 'sans-serif',
  flexGrow: 1,
  color: palette.visitor.input.color,
  input: {
    '&::placeholder': {
      opacity: 0.9,
      color: palette.visitor.input.placeholder,
      fontWeight: 500,
    },
  },
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  // fontSize: '0.8rem',
  // fontWeight: 900,
  fontFamily: 'sans-serif',
  flexGrow: 1,
  color: palette.visitor.input.color,
  border: 'none',
  input: {
    fontSize: '0.8rem',
    fontWeight: 900,
    '&::placeholder': {
      opacity: 0.9,
      color: palette.visitor.input.placeholder,
      fontWeight: 900,
      fontSize: '0.8rem',
    },
  },
}));

export const ButtonContained = styled(LoadingButton)(({ theme }) => ({
  background: 'linear-gradient(180deg, #5E00D5, #4F0075)',
  border: '1px solid #FFB9EB',
  boxShadow: '0px 0px 5px 2px #8000FF',
  borderRadius: 10,
  padding: '6px 4px',
}));

export const ThemeButton = styled(LoadingButton)(({ theme }) => ({
  background: palette.button.bg,
  color: palette.visitor.login.color,
  borderRadius: 8,
  border: palette.button.border,
  // boxShadow: palette.button.shadow,
  fontSize: '0.8rem',
}));

export const AuthButtons = styled(LoadingButton)(({ theme }) => ({
  background: palette.button.bg2,
  color: '#fff',
  borderRadius: 8,
  border: palette.button.border2,
  boxShadow: palette.button.shadow,
  fontSize: '0.8rem',
}));

export const TitleBar = styled(Box)(({ theme }) => ({
  width: '30%',
  minWidth: '150px',
  height: '35px',
  background: 'linear-gradient(to bottom, #4d4d4d, #262626)',
  color: 'white',
  fontSize: '24px',
  textAlign: 'center',
  borderBottomLeftRadius: '30px',
  borderBottomRightRadius: '30px',
  border: '3px solid #262626',
  //   boxShadow: '0 5px 10px rgba(0, 0, 0, 0.5)',
  padding: '10px',
  borderTop: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const TableHeadCustomStyle = {
  backgroundColor: 'black',
  borderCollapse: 'separate',
  '& th': {
    borderTop: '1px solid white',
    borderBottom: '1px solid white',
    color: 'white',
  },
  '& th:first-of-type': {
    paddingLeft: 2,
    borderLeft: '1px solid white',
    borderTop: '1px solid white',
    borderBottom: '1px solid white',
  },
  '& th:last-of-type': {
    paddingRight: 2,
    borderRight: '1px solid white',
    borderTop: '1px solid white',
    borderBottom: '1px solid white',
  },
};
